module.exports = __webpack_public_path__ + "img/logo_white.7c61db91.png";